import React from 'react';
import { Route, Routes } from 'react-router-dom';
import Layout from '../../components/Layout/Layout';
import RolesPermissionsDashboard from '../RolesPermissionsDashboard/RolesPermissionsDashboard';

const RolesPermissionsLayout = () => {
  return (
    <>
        <Routes>
            <Route element={<Layout />}>
                <Route index element={<RolesPermissionsDashboard />} />
                <Route path="dashboard" element={<RolesPermissionsDashboard />} />
            </Route>
        </Routes>
    </>
  );
};

export default RolesPermissionsLayout